// Copy for the "Select your preferences" screen. Chrome/labels only — the offering data
// (modality, duration, provider label) comes from the BFF and is composed at render time.
// English-only literal strings, like the rest of this package.

import type { Offering } from "./hooks"

// The visit-type card copy, keyed by the offering's `appointmentType`. `visitNoun` is a lowercase
// fragment that only reads right after a duration, so render it through `visitTitle`, not alone.
const APPOINTMENT_TYPE_COPY: Record<Offering["appointmentType"], { visitNoun: string; description: string }> = {
  initial: {
    visitNoun: "initial visit",
    description: "We'll match you with the first available clinician."
  },
  follow_up: {
    visitNoun: "follow-up visit",
    description: "Continue with a Carrot Clinic clinician you've met with before."
  }
}

export function appointmentTypeCopy(appointmentType: Offering["appointmentType"]): {
  visitNoun: string
  description: string
} {
  return APPOINTMENT_TYPE_COPY[appointmentType]
}

// Shared by the scheduling and Booked cards so the two booking screens name the visit the same way.
// The appointments list names visits separately (appointments/appointmentTypeLabels.ts).
export function visitTitle(durationMinutes: number, appointmentType: Offering["appointmentType"]): string {
  return `${durationMinutes}-minute ${appointmentTypeCopy(appointmentType).visitNoun}`
}
